import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { action, makeObservable, observable } from 'mobx';
import type { SupportTicket, SupportTicketResponse } from '@bringg/types';
import { BringgException } from '@bringg/dashboard-sdk/dist/Core/BringgException';
import type { UploadChangeParam } from 'antd/lib/upload';

import { uploadTicketAttachments } from '../upload-ticket-attachments';

export class SupportTicketStore {
	loading = false;

	constructor() {
		makeObservable(this, {
			loading: observable,
			setIsLoading: action
		});
	}

	setIsLoading = (isLoading: boolean) => {
		this.loading = isLoading;
	};

	get isLoading(): boolean {
		return this.loading;
	}

	get dashboardSdk() {
		return getRootEnv().dashboardSdk.sdk;
	}

	createSupportTicket = async (params: SupportTicket): Promise<SupportTicketResponse> => {
		try {
			return await this.dashboardSdk.supportTicket.createSupportTicket(params);
		} catch (error) {
			console.error(error);

			// dashboard-sdk throws a BringgException with the real Salesforce error on `details`
			// (even on HTTP 200 when the response body has success:false); return a shaped object so
			// the submit drawer can surface the actual message instead of a generic fallback toast.
			const { details, message } = (error ?? {}) as BringgException;

			return { success: false, message: (details as string) ?? message } as SupportTicketResponse;
		}
	};

	uploadAttachments = async (filesList: UploadChangeParam['fileList'], caseId: string) => {
		try {
			const { user, config } = this.dashboardSdk.session;
			const { host, protocol } = config.getAuthenticationEndpoint();

			return await uploadTicketAttachments({
				filesList,
				caseId,
				token: String(user.authentication_token),
				apiUrl: `${protocol}//${host}`
			});
		} catch (error) {
			console.error(error);
		}
	};
}
